import { render, staticRenderFns } from "./ModalTerms.vue?vue&type=template&id=08215cf7&"
import script from "./ModalTerms.vue?vue&type=script&lang=js&"
export * from "./ModalTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports